import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import partnerEventAPI from '@infrastructure/partner-event-api';
export const createPartnerEventAsync = createAsyncThunk('PartnerEvent/create', async (event, { rejectWithValue }) => {
    try {
        const response = await partnerEventAPI.createPartnerEvent(event);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updatePartnerEventAsync = createAsyncThunk('PartnerEvent/update', async (event, { rejectWithValue }) => {
    try {
        const response = await partnerEventAPI.updatePartnerEvent(event);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPartnerEventMonthlyAsync = createAsyncThunk('PartnerEvent/get-monthly', async (event, { rejectWithValue }) => {
    try {
        const response = await partnerEventAPI.getPartnerEvents(event);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPartnerEventDetailsAsync = createAsyncThunk('PartnerEvent/get-details', async (event, { rejectWithValue }) => {
    try {
        const response = await partnerEventAPI.getPartnerEventDetails(event);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
